import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import cloudLogo from '../assets/images/cloud.png';
import styles from './Header.module.css';

const Header: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <header className={styles.header}>
        <div className={styles.headerLeft}>
          <img src={cloudLogo} alt="Cloud Logo" className={styles.cloudLogo} />
        </div>

        <button
          className={styles.mobileMenuToggle}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span className={`${styles.hamburger} ${isMobileMenuOpen ? styles.open : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        <nav className={`${styles.navigation} ${styles.desktopNav}`}>
          <Link to="/" className={`${styles.navItem} ${isActive('/') ? styles.active : ''}`}>
            {t('navigation.home')}
          </Link>
          <Link to="/project" className={`${styles.navItem} ${isActive('/project') ? styles.active : ''}`}>
            {t('navigation.project')}
          </Link>
          <Link to="/achievement" className={`${styles.navItem} ${isActive('/achievement') ? styles.active : ''}`}>
            {t('navigation.achievement')}
          </Link>
          <Link to="/impact" className={`${styles.navItem} ${isActive('/impact') ? styles.active : ''}`}>
            {t('navigation.impact')}
          </Link>
          <Link to="/contact" className={`${styles.navItem} ${isActive('/contact') ? styles.active : ''}`}>
            {t('navigation.contact')}
          </Link>
        </nav>
      </header>

      {isMobileMenuOpen && (
        <div
          className={styles.mobileMenuOverlay}
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      <nav className={`${styles.navigation} ${styles.mobileNav} ${isMobileMenuOpen ? styles.mobileOpen : ''}`}>
        <Link
          to="/"
          className={`${styles.navItem} ${isActive('/') ? styles.active : ''}`}
          onClick={() => setIsMobileMenuOpen(false)}
        >
          {t('navigation.home')}
        </Link>
        <Link
          to="/project"
          className={`${styles.navItem} ${isActive('/project') ? styles.active : ''}`}
          onClick={() => setIsMobileMenuOpen(false)}
        >
          {t('navigation.project')}
        </Link>
        <Link
          to="/achievement"
          className={`${styles.navItem} ${isActive('/achievement') ? styles.active : ''}`}
          onClick={() => setIsMobileMenuOpen(false)}
        >
          {t('navigation.achievement')}
        </Link>
        <Link
          to="/impact"
          className={`${styles.navItem} ${isActive('/impact') ? styles.active : ''}`}
          onClick={() => setIsMobileMenuOpen(false)}
        >
          {t('navigation.impact')}
        </Link>
        <Link
          to="/contact"
          className={`${styles.navItem} ${isActive('/contact') ? styles.active : ''}`}
          onClick={() => setIsMobileMenuOpen(false)}
        >
          {t('navigation.contact')}
        </Link>
      </nav>
    </>
  );
};

export default Header;